import React, { useEffect, useState } from "react";
import "../viewUser/viewUser.css";
import { useParams } from "react-router-dom";
import UserService from "../../services/UserService";

const ViewUser = () => {
  const [viewUser, setViewUser] = useState({});
  console.log("viewUser", viewUser);

  const params = useParams();

  const getViewUser = async () => {
    try {
      const response = await UserService.getUser(params.id);
      if (response) {
        setViewUser(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getViewUser();
  }, []);

  return (
    <div className="container mb-5">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="eye-outline"></ion-icon>
          <span className="text">View User</span>
        </div>
      </div>

      <div className="mt-4">
        <div className="userInfo">
          <label>Name</label>
          <div>Jack</div>
        </div>
        <div className="userInfo mt-4">
          <label>Mobile Number</label>
          <div>{viewUser.phoneNumber}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Country</label>
          <div>{viewUser.country}</div>
        </div>
        <div className="userInfo mt-4">
          <label>City</label>
          <div>{viewUser.city}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Gender</label>
          <div className="round-bg">{viewUser.gender}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Age Group</label>
          <div>{viewUser.ageGroup}</div>
        </div>
        <div className="userInfo mt-4">
          <label>Status</label>
          <div className="round-bg">{viewUser.status}</div>
        </div>
      </div>
    </div>
  );
};

export default ViewUser;
